export enum RoutePaths {
  main = '/',
  imprint = '/imprint',
  privacy = '/privacy',
}
